(ns app.admin.config.util
  "Group or group-config configuration utilities for the group admin"
  (:require [app.domain.group.config.model :as config-model]
            [core.util.util :as util]
            [potpuri.core :as p]))

(defn ->group-attr
  "Returns a group-config attribute's corresponding group attribute"
  [attr]
  (some->> attr name (keyword "group")))


(defn ->config-attr
  "Returns a group attribute's corresponding group-config attribute"
  [attr]
  (some->> attr name (keyword "group.config")))


(defn- used-prefixes-by-auth-group
  "Returns prefixes in use in the authority-group as a map of prefix->common-counter?
  Note that the common-number-seq means sharing the group's counter so for the group
  it doesn't exist as an attribute and is here set to always true unless the group has
  specifically been excluded from the results"
  [group excluded-entity-id prefix-attr common-attr]
  (let [group-configs (->> group
                           :group.config/_group
                           (remove (some-fn config-model/soft-removed?
                                            #(= (:db/id %) excluded-entity-id))))
        group-entry   (when (not= (:db/id group) excluded-entity-id)
                        [(get group (->group-attr prefix-attr)) true])]
    (->> group-configs
         (map (juxt (->config-attr prefix-attr) common-attr))
         (cons group-entry)
         (into {})
         (p/remove-keys nil?))))


(defn case-id-prefix-in-use?
  "Returns whether the prefix is in use in some other `group.config`.
  The same prefix can be used if all the occurrences use the same common counter"
  [group-or-config group prefix-attr common-attr & [prefix-override common-override]]
  (let [prefix               (or prefix-override
                                 (get group-or-config prefix-attr))
        use-common-counter?  (or common-override
                                 (get group-or-config common-attr))
        prefix->common       (used-prefixes-by-auth-group group
                                                          (:db/id group-or-config)
                                                          :group.config/municipal-case-id-prefix
                                                          :group.config/municipal-case-id-common-counter?)
        matching-prefixes    (p/filter-keys #(= prefix %) prefix->common)
        matching-common-vals (vals matching-prefixes)]
    (or (not-every? true? matching-common-vals)
        (and (not use-common-counter?)
             (seq matching-common-vals)))))


(defn prefix-valid?
  "The prefix is valid if it is nil (template not used) or if it is not blank and not already in use
  (except with other configs that share the same common counter (= group's counter)"
  [group-config group prefix-attr common-attr]
  (or (nil? (get group-config prefix-attr))
      (and (not (case-id-prefix-in-use? group-config group prefix-attr common-attr))
           (-> group-config (get prefix-attr) util/blank-string? not))))
